// removed by extract-text-webpack-plugin
module.exports = {"field-wrapper":"app-pages-Library-Category-CategoryDetail-__style___13aXB","wrapper":"app-pages-Library-Category-CategoryDetail-__style___3I5Z9","title":"app-pages-Library-Category-CategoryDetail-__style___3O-GH","footer":"app-pages-Library-Category-CategoryDetail-__style___2pqBJ","btn-save":"app-pages-Library-Category-CategoryDetail-__style___Phtzj","btn-cancel":"app-pages-Library-Category-CategoryDetail-__style___2D7tC"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Category/CategoryDetail/style.css
// module id = 769
// module chunks = 0